export const getDashboardCount = (contacts = []) => contacts?.filter(({dashboard}) => dashboard?.length > 0)?.length;

export const getContactListCount = (contacts = []) => {
	return contacts.filter(({contactList}) => contactList?.hasAccess).length;
};

const normalizeContacts = (contacts, entityAdmins) => {
	return contacts.map((contact) => {
		return {
			...contact,
			hasAccess: contact.contactList?.hasAccess || entityAdmins.find(admin => admin.userId === contact.userId)?.accessToContactList,
			tags: !!contact?.tags ? [...contact.tags] : []
		};
	});
};

export const mapEntities = ({
	id,
	label: entityName,
	engagements,
	entityLevel: level,
	parentId,
	contacts,
	entityId,
	entityAdmins
}) => ({
	id,
	entityId,
	entityName,
	engagements,
	level,
	contacts: normalizeContacts(contacts, entityAdmins),

	engagementCount: engagements.length,
	contactsCount: contacts.length,
	dashboardCount: getDashboardCount(contacts),
	contactListCount: getContactListCount(contacts),

	parentId,
	entityAdmins
});

// Load data for selected entity nodes
const recursiveSorting = (node, entities, pushToSorted) => {
	// Check if entity is selected
	const entity = entities.find((x) => x.entityId === node.entityId);

	if (entity) pushToSorted(entity);

	// load children entities for each node
	node.nodes.forEach((n) => {
		recursiveSorting(n, entities, pushToSorted);
	});
};

export const sortEntities = (data, orgChart) => {
	const sorted = [];
	const pushToSorted = (items) => sorted.push({...items});
	orgChart?.forEach((node) => {
		recursiveSorting(node, data, pushToSorted);
	});
	return sorted;
};

export default (entities, orgChart) => {
	const mappedData = entities.map(mapEntities);
	return sortEntities(mappedData, orgChart);
};
